import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/client-portal-shared/components';
import {
  useBodyBackgroundColor,
  useBorrowerPortalMediaQueries,
} from '@roc/feature-app-core';
import { observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { VerticalLinearStepper } from './verticalLinearStepper';
import { ProgressBar } from 'libs/feature-borrowers/src/caf/components/progressBar';

const useStyles = makeStyles((theme: Theme) => ({
  containerWrapper: {
    padding: '0 16px',
    marginTop: 0,
  },
  paper: {
    padding: theme.spacing(2),
  },
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  sigCanvas: {
    width: '100%',
    height: 200,
    background: '#f7f7f7',
    border: '1px solid #aaa',
    borderRadius: 16,
  },
}));

export const IdVerificationLayout = observer(
  ({ title, steps, children, active, complete, SuccessScreen }) => {
    const classes = useStyles();
    const [currentActive, setCurrentActive] = useState(active);
    const [nextDisabled, setNextDisabled] = useState(false);
    const [percentCompleted, setPercentCompleted] = useState(0);
    const { isSmallScreen, isLargeScreen } = useBorrowerPortalMediaQueries();
    const swiperRef = useRef<any>(null);

    const [completed, setCompleted] = useState(false);

    useBodyBackgroundColor('#fff');

    useEffect(() => {
      setPercentCompleted(active * (100 / steps.length + 1));
      if (active > currentActive) {
        swiperRef.current?.slideNext();
      } else if (active < currentActive) {
        swiperRef.current?.slidePrev();
      }
      setCurrentActive(active);
    }, [active]);

    useEffect(() => {
      if (complete) {
        setCompleted(true);
        setPercentCompleted(100);
      }
    }, [complete]);

    return (
      <Layout maxWidth="lg" bodyContentBoxClass={classes.containerWrapper}>
        <Box mb={4} textAlign={'left'}>
          <Typography variant={isSmallScreen ? 'h4' : 'h3'}>{title}</Typography>
          <Box>
            <ProgressBar value={percentCompleted} />
          </Box>
        </Box>
        {!complete && (
          <Grid container spacing={2}>
            <Grid item xs zeroMinWidth>
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                onSlideChange={swiper => {
                  //setActive(swiper.realIndex);
                }}
                onSwiper={swiper => {
                  swiperRef.current = swiper;
                }}
                allowTouchMove={false} // Prevents user swiping if not needed
              >
                {steps.map((step, index) => (
                  <SwiperSlide
                    key={index}
                    style={{
                      padding: '0 2px',
                    }}
                  >
                    {children[index]}
                  </SwiperSlide>
                ))}
              </Swiper>
              <Grid item xs={12} sm={12}>
                <Box
                  mt={4}
                  display={'flex'}
                  justifyContent={active == 0 ? 'flex-end' : 'space-between'}
                >
                  {steps[active].allowBack && active != 0 && (
                    <Button
                      variant="outlined"
                      color="default"
                      startIcon={<ArrowBack />}
                      size="large"
                      onClick={() => steps[active].onBack()}
                      style={{
                        padding: '16px 24px',
                      }}
                    >
                      Back
                    </Button>
                  )}
                  {steps[active].allowNext && (
                    <Button
                      variant="contained"
                      color="primary"
                      endIcon={
                        active == steps.length - 1 ? null : <ArrowForward />
                      }
                      size="large"
                      onClick={() => steps[active].onNext()}
                      disabled={nextDisabled}
                      style={{
                        padding: '16px 24px',
                      }}
                    >
                      {active == steps.length - 1 ? 'Submit' : 'Next'}
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>

            {isLargeScreen && (
              <Grid
                item
                style={{
                  height: '100%',
                  width: '1px',
                  background: '#ddd',
                  margin: '0 24px',
                  padding: 0,
                }}
              ></Grid>
            )}
            {isLargeScreen && (
              <Grid item style={{ width: 280 }}>
                <VerticalLinearStepper active={active} steps={steps} />
              </Grid>
            )}
          </Grid>
        )}
        {complete && (
          <Grid container spacing={2}>
            <Grid item xs zeroMinWidth>
              <SuccessScreen />
            </Grid>
          </Grid>
        )}
      </Layout>
    );
  }
);
